import { useMemo } from 'react';
import { ApplicationConfig } from '../../config/config';
import { getDirectConnectClientUrl } from '../helper/direct-connect-helper';
import { DirectConnectRegistration } from '../registration/direct-connect-registration';

const DirectConnectKioskRoute = () => {
  const url = useMemo(() => {
    return getDirectConnectClientUrl(ApplicationConfig.robot.network.host);
  }, []);

  return <DirectConnectRegistration url={url} />;
};

export { DirectConnectKioskRoute };
